<template>
	<SharedGroupItem
		:workflow="workflow"
		:nestedLevelIndex="0"
		:group="everyoneGroup"
		:usersSharedData="usersSharedData"
		:hideVisibilityStatus="hideVisibilityStatus"
		:sharedData="[everyoneSharedData, ...groupsSharedData]"
	/>
</template>

<script>
import { mapGettersShorthand } from '@/store/utils/mappers';
import { teamMembers } from '@/store/modules/account/getters';
import SharedGroupItem from '@/components/dialogs/ShareFeatureDialog/ExistingShareList/SharedGroupItem.vue';
import ShareModuleDialogService from '@/components/dialogs/ShareModuleDialog/share-module-dialog-service.js';
export default {
	name: 'SharedEveryoneGroup',
	components: { SharedGroupItem },
	props: {
		workflow: { type: Object },
		usersSharedData: { type: Array },
		groupsSharedData: { type: Array },
		hideVisibilityStatus: { type: Boolean },
	},
	computed: {
		...mapGettersShorthand({ teamMembers }),
		everyoneGroup() {
			return ShareModuleDialogService.getFakeEveryoneGroup(this.teamMembers);
		},
		everyoneSharedData() {
			return { id: this.everyoneGroup.id, is_on: true };
		},
	},
};
</script>
